__turbopack_context__.v({
  "backgroundImageWrapper": "VariantHeroSection-module__cpAvpa__backgroundImageWrapper",
  "desktopMarqueeWrapper": "VariantHeroSection-module__cpAvpa__desktopMarqueeWrapper",
  "heroSection": "VariantHeroSection-module__cpAvpa__heroSection",
  "imageHalf": "VariantHeroSection-module__cpAvpa__imageHalf",
  "mobileMarqueeWrapper": "VariantHeroSection-module__cpAvpa__mobileMarqueeWrapper",
  "mobileText": "VariantHeroSection-module__cpAvpa__mobileText",
  "mobileTextSection": "VariantHeroSection-module__cpAvpa__mobileTextSection",
  "slantedText": "VariantHeroSection-module__cpAvpa__slantedText" + " " + __turbopack_context__.i(527070)["body2"],
  "slantedTextOverlay": "VariantHeroSection-module__cpAvpa__slantedTextOverlay",
  "styledImage": "VariantHeroSection-module__cpAvpa__styledImage",
  "styledPicture": "VariantHeroSection-module__cpAvpa__styledPicture",
});
